import { 
  avContract

        } from "./ConAddsAndABIs"
import React, { useEffect, useState } from "react";

function TheAirdropVault(){

const [walletAddress, setWalletAddress] = useState(""); 

const [bottomPrice, setBottomPrice] = useState(""); 
const [airdropSafe, setAirdropSafe] = useState('');
const [airdropStatus, setAirdropStatus] = useState('');
const [airdropButton, setAirdropButton] = useState('');

useEffect(() => {  
 
    const getWalletAddress = async () => {
      const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
      });
      const account = accounts[0]
      const accountF = account.toString()
      setWalletAddress(accountF);
    }

      getWalletAddress()
        .catch(console.error)  

// - - - - - - - - - - 
const getTotalUsdtRewards = async () => {
    const a = await avContract.airdropAmount(walletAddress) / (10**18);
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0});
    const c = await avContract.getDlvSellingPrice() / (10**6);
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6});
    const e = await avContract.isClaimed(walletAddress)

    setAirdropSafe(b)
    setBottomPrice(d)
    if(e === false && a > 0) {
      setAirdropStatus("Not Yet Claimed")
      setAirdropButton(<button style={{"width": "150px"}} type={"submit"} className="btn btn-success" onClick={handleBuySafeValueSubmit}>Claim Airdrop</button>)
    } else {
      setAirdropStatus("Claimed")
      setAirdropButton()
    }



  }  

  getTotalUsdtRewards()
  .catch(console.error)


})
   
const handleBuySafeValueSubmit = async (e) => {
    e.preventDefault();
    const txnb = await avContract.claimAirdrop()
    await txnb.wait();
    }

return ( 
  <div>
        <h2>The Airdop Vault</h2><br/>

        <p>Airdrop Amount: {airdropSafe}*</p>
        <p>Airdrop Status: {airdropStatus}</p>
        <p>Current Bottom Price: {bottomPrice}</p>
        <p><em>*The amount becomes claimable once the bottom price reaches 0.000050 USDC per $SAFE.</em></p>
        {airdropButton}

  

  </div>
  
)

}


export default TheAirdropVault;